import type { FC } from 'react'
import { useEffect } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import { twJoin } from 'tailwind-merge'
import {
  IconSunHigh as IconLight,
  IconMoon as IconDark,
} from '@tabler/icons-react'

import useStorage from '@/lib/hooks/useStorage'

export const Theme: FC = () => {
  const [theme, setTheme] = useStorage('theme')

  useEffect(() => {
    document.body.classList.remove(theme === 'dark' ? 'light' : 'dark')
    document.body.classList.add(theme)
  }, [theme])

  return (
    <button
      title={theme === 'dark' ? 'Dark' : 'Light'}
      onClick={() => setTheme(t => (t === 'dark' ? 'light' : 'dark'))}
      className={twJoin(
        'relative flex items-center justify-center',
        'size-10 rounded-full bg-transparent shadow-none',
        'text-stone-900 dark:text-stone-100'
      )}
    >
      <AnimatePresence>
        {theme === 'dark' && (
          <motion.span
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            className='absolute'
          >
            <IconDark />
          </motion.span>
        )}
      </AnimatePresence>
      <AnimatePresence>
        {theme === 'light' && (
          <motion.span
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            className='absolute'
          >
            <IconLight />
          </motion.span>
        )}
      </AnimatePresence>
    </button>
  )
}

export default Theme
